const app_net_states = state => state.app_net_states
const app_net_state = state => state.app_net_state
const app_net_list_view = state => state.app_net_list_view
const app_net_revisions = state => state.app_net_revisions
const app_net_revisions_view = state => state.app_net_revisions_view
const user_error = state => state.user_error
const application_network_state = state => state.application_network_state

export default {
  app_net_states,
  app_net_state,
  app_net_list_view,
  app_net_revisions,
  app_net_revisions_view,
  user_error,
  application_network_state,
}



// WEBPACK FOOTER //
// ./src/modules/applicationNetworkStates/store/getters.js